// extracted by mini-css-extract-plugin
module.exports = {"root":"Expand_root__bjkCd","expander":"Expand_expander__0btEa","text":"Expand_text__Ljdi_"};